import React, {useEffect, useState} from "react";
import {AlertTypes, IAlertData, setAlert, SmartSelect, TextField} from "@leap4/frontend";
import {IPLData} from "../../modules/home/home";
import {Dispatch} from 'redux';

interface IPublisherLoginsSelectProps {
    selectedPL: string,
    publisherLogins: IPLData[],
    isLoading: boolean,
    setSelectedPL: (plId: string) => void,
    setAlert: ({msg, type, d, timeout}: IAlertData) => (d: Dispatch<any>) => void
}

export const PublisherLoginsSelect = ({
                                          selectedPL,
                                          publisherLogins,
                                          isLoading,
                                          setSelectedPL,
                                          setAlert
                                      }: IPublisherLoginsSelectProps) => {
    const [selectedIdx, setSelectedIdx] = useState(0);
    const handleChange = (idx: number) => {
        const selectedPL = publisherLogins[idx];
        setSelectedPL(selectedPL.pLId)
    }

    const getPlaceholder = () => {
        if (!publisherLogins) return 'Loading';
        if (!publisherLogins.length) return 'No publisher logins';
        else return 'Choose A Publisher Login';
    }

    const getSelectedInd = () => {
        return publisherLogins?.findIndex(p => p.pLId === selectedPL)
    }

    useEffect(() => {
        const idx = publisherLogins?.findIndex(p => p.pLId === selectedPL);
        setSelectedIdx(idx > -1 ? idx : 0);
    }, [publisherLogins, selectedPL]);

    const items = publisherLogins?.map(o => ({name: o.pLName, value: o.pLId}))
    const inputProps = {
        style: {
            color: 'white',
            WebkitTextFillColor: 'white',
            border: '1px solid #001080'
        }
    }
    return <>
        {items?.length ? <SmartSelect items={items}
                                      selectedItemInd={selectedIdx}
                                      setSelectedState={handleChange}
                                      selectProps={{size: 'small', fullWidth: true, ...inputProps}}
                                      disabled={isLoading}
                                      textFieldProps={{inputProps: {...inputProps}}}

            /> :
            <TextField placeholder={"No Publisher Logins"} size={"small"}
                       style={{color: 'white',width:'100px'}}
                       disabled

                       inputProps={{...inputProps}} />
        }


    </>
}